import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rc-content-group" }


export default /*@__PURE__*/_defineComponent({
  __name: 'RcContentGroup',
  setup(__props) {

/**
 * A group of related content, stacked 16px apart.
 *
 * RcSection already stacks its default slot 16px apart, so form elements
 * written straight into a section need no wrapper of their own. A section that
 * needs several groups writes an RcContentGroup per group instead, and the
 * section spaces those groups 24px apart.
 *
 * The component is not tied to RcSection, so it can also be used on its own
 * wherever a 16px column is wanted.
 *
 * Example:
 *
 * <RcSection title="Section title" mode="with-header">
 *   <RcContentGroup>
 *     <LabeledInput label="Name" />
 *     <LabeledInput label="Description" />
 *   </RcContentGroup>
 *   <RcContentGroup>
 *     <LabeledInput label="Namespace" />
 *   </RcContentGroup>
 * </RcSection>
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})